<template>
  <v-container fluid style="min-height: 500px; ">
    <v-layout justify-center>
      <v-flex lg12 md12>
        <loading :active.sync="isLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>
        <b-table
          striped
          hover
          :items="data"
          :fields="fields"
          dark>
          <template slot="show_details" slot-scope="row">
            <b-button size="sm" @click.stop="row.toggleDetails" class="mr-2">
              {{ row.detailsShowing ? 'Hide' : 'Show'}} Details
            </b-button>
          </template>
          <template  slot="row-details" slot-scope="row">
              <b-card v-for="detail in row.item.item" :key="detail.id" bg-variant="dark" text-variant="white">
                <b-row class="mb-2">
                  <b-col sm="3" class="text-sm-right"><b>Index:</b></b-col>
                  <b-col>{{ detail.index }}</b-col>
                  <b-col sm="3" class="text-sm-right"><b>Value:</b></b-col>
                  <b-col>{{ detail.volume }}</b-col>
                  <b-col sm="3" class="text-sm-right"><b>Day:</b></b-col>
                  <b-col>{{ detail.day }}</b-col>
                </b-row>
              </b-card>
              <b-card bg-variant="dark" text-variant="white">
                <b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>
              </b-card>
          </template>
        </b-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    Loading
  },
  data () {
    return {
      result: [],
      data: [],
      fields: ['Username', 'Licen', 'volume', 'day', 'show_details'],
      isLoading: false,
      fullPage: true
    }
  },
  created () {
    this.getstatusvolume()
  },
  methods: {
    async getstatusvolume () {
      this.isLoading = true
      await axios.get(apiUrl + '/api/status/getstatusVolume').then(response => {
        this.result = response.data.volume
        console.log(this.result)
        for (let element of response.data.volume) {
          let val = 0
          let day = 0
          for (let elements of element.value) {
            if (typeof elements.volume === 'number') {
              val = val + elements.volume
              elements.volume = `${((elements.volume / 1024 / 1024 / 1024).toFixed(2)) * 1} GB`
              if (elements.day > day) {
                day = elements.day
              }
            }
          }
          var useGB = ((val / 1024 / 1024 / 1024).toFixed(2)) * 1
          var status = ''
          // Conditional (ternary) operator
          parseInt(element.lic) < useGB
            ? status = 'danger'
            : status = 'success'
          if (parseInt(day) === 0) {
            status = 'danger'
            useGB = 'no connection'
            day = 'no connection'
          } else {
            useGB = `${useGB} GB`
            day = `${day} Day`
          }
          this.data.push({
            Username: element.username,
            Licen: `${element.lic} GB`,
            volume: useGB,
            day: day,
            _rowVariant: status,
            item: element.value
          })
        }
        this.isLoading = false
      }).catch(e => {
        console.log(e)
        alert(e.response.data.msg)
      })
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/monitorVolume.vue